module.exports = __webpack_public_path__ + "static/clave-ee7aa6b3fcab31f24a4cda688fa9c1ba.wav";